<style scoped>
    .diff{
        position: relative;
    }
</style>
<template>
    <div class="diff">
        <Modal v-model="modal" v-if="type === 'modal'">
            <Spin fix v-if="loading" size="large"></Spin>
            <div ref="delta" v-html="delta_html">-</div>
        </Modal>
        <Spin fix v-if="loading && type === 'text'" size="large"></Spin>
        <div ref="delta" v-html="delta_html" v-if="type === 'text'">-</div>
    </div>
</template>
<script>
    import OnlineUtil from '../libs/util';
    const Diff = require('jsondiffpatch');
    Diff.formatters.html.hideUnchanged();
    const DiffPatcher = require('jsondiffpatch').create({
        objectHash: function (obj) {
            return obj['内部简称'] || obj['内部编码'];
        },
        textDiff: {
            // default 60, minimum string length (left and right sides) to use text diff algorythm: google-diff-match-patch
            minLength: 5
        }
    });
    export default {
        props: {
            /* modal or text
            * modal 通过 show 方法传递 id，显示模态框
            * text 通过 props 传递 id 显示文本
            * */
            type: {
                type: String,
                default: 'modal'
            },
            item_id: {
                type: Number,
                default: 0
            }
        },
        data(){
            return {
                modal: false,
                loading: false,
                old_item: {},
                new_item: {},
                old: {
                    "id": 1,
                    "mall_item_id": 1,
                    "apply_user_id": 202,
                    "apply_user": "马良焰",
                    "fill_user_id": 202,
                    "fill_user": "马良焰",
                    "channel_id": 100,
                    "title": "《百词斩象形9000》英语单词词汇书 日常 中考 高考 四级 六级 托福 雅思组合套装",
                    "formal_title": "《象形9000》单词书",
                    "short_name": "象形9000全套",
                    "desc": "记单词，不枯燥，词汇量，速破万！",
                    "image_small": "/image/items/m/uploads/1569661222697.jpg",
                    "image_normal": "/image/items/m/uploads/1569661262745.jpg;/image/items/m/uploads/1569661285082.jpg;/image/items/m/uploads/1569661329278.jpg;/image/items/m/uploads/1569661336568.jpg",
                    "description": "<img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/6db628d7c390.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e31de7d154ca.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e73465acad73.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/d679d4aaf0cf.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a5bbdf9a28ed.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/8b722b00e70e.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/2421e387d7d0.jpg\" alt=\"\" /><a href=\"http://mall.baicizhan.com/m/item?id=2002200\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a0d53f2c713b.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002201\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/635c64031b68.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002202\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a4cb7685ca7f.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002199\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/339db88b703b.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003374\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/34b6a2bd993e.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003372\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/f313369a7cef.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003371\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/872348f82dbf.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003370\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/0d166b3c3e84.jpg\" alt=\"\" /></a>",
                    "category_id": 3,
                    "item_type": 0,
                    "show_type": 0,
                    "extra_tag": "非赠品",
                    "display_url": "",
                    "notify_url": "",
                    "jump_url": "",
                    "third_md5_key": "",
                    "free_postage": false,
                    "sale_time": null,
                    "auto_refund_deadline": null,
                    "extra_info": "{}",
                    "status": 1,
                    "created_at": "2019-10-12T11:24:19.000+08:00",
                    "updated_at": "2019-10-12T11:24:19.000+08:00",
                    "mall_online_sub_items": [
                        {
                            "id": 0,
                            "mall_online_item_id": 1,
                            "item_id": 0,
                            "sub_item_id": 0,
                            "title": "12341s24",
                            "price": "105.0",
                            "inner_name": "ZB00102V1-TXFF",
                            "remain": 0,
                            "url_image": "/image/items/m/uploads/1489136683902.jpg",
                            "extra_info": "{}",
                            "status": 1,
                            "created_at": "2019-10-12 11:24:19 +0800",
                            "updated_at": "2019-10-12 11:24:19 +0800"
                        },
                        {
                            "id": 1,
                            "mall_online_item_id": 1,
                            "item_id": 0,
                            "sub_item_id": 0,
                            "title": "1234124",
                            "price": "100.0",
                            "inner_name": "ZB00102V1-TXFF",
                            "remain": 0,
                            "url_image": "/image/items/m/uploads/1489136683903.jpg",
                            "extra_info": "{}",
                            "status": 1,
                            "created_at": "2019-10-12 11:24:19 +0800",
                            "updated_at": "2019-10-12 11:24:19 +0800"
                        },
                        {
                            "id": 2,
                            "mall_online_item_id": 1,
                            "item_id": 0,
                            "sub_item_id": 0,
                            "title": "vsdfga",
                            "price": "69.9",
                            "inner_name": "ZB00102-TXSB",
                            "remain": 0,
                            "url_image": "/image/items/m/uploads/1489136683903.jpg",
                            "extra_info": "{}",
                            "status": 1,
                            "created_at": "2019-10-12 11:24:19 +0800",
                            "updated_at": "2019-10-12 11:24:19 +0800"
                        }
                    ]
                },
                new: {
                    "id": 1,
                    "mall_item_id": 1,
                    "apply_user_id": 202,
                    "apply_user": "马良焰",
                    "fill_user_id": 202,
                    "fill_user": "马良焰",
                    "channel_id": 200,
                    "title": "《百词斩象形9000》英语词汇书 日常 中考 高考 四级 六级 托福 雅思组合套装",
                    "formal_title": "《象形9000》单词书",
                    "short_name": "象形9000全套",
                    "desc": "记单sd词，不枯燥，词汇量，速破万！",
                    "image_small": "/image/items/m/uploads/1569661222697.jpg",
                    "image_normal": "/image/items/m/uploads/1569661262745.jpg;/image/items/m/uploads/123124235435.jpg;/image/items/m/uploads/1569661329278.jpg;/image/items/m/uploads/1569661336568.jpg",
                    "description": "<img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/6db628d7c390.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e31de7d154ca.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/e73465acad73.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/d679d4aaf0cf.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a5bbdf9a28ed.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/8b722b00e70e.jpg\" alt=\"\" /><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/2421e387d7d0.jpg\" alt=\"\" /><a href=\"http://mall.baicizhan.com/m/item?id=2002200\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a0d53f2c713b.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002201\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/635c64031b68.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002202\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/a4cb7685ca7f.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2002199\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/339db88b703b.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003374\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/34b6a2bd993e.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003372\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/f313369a7cef.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003371\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/872348f82dbf.jpg\" alt=\"\" /></a><a href=\"http://mall.baicizhan.com/m/item?id=2003370\"><img src=\"http://fulfillment.bczcdn.com/rc201603281546/image/items/m/uploads/0d166b3c3e84.jpg\" alt=\"\" /></a>",
                    "category_id": 3,
                    "item_type": 0,
                    "show_type": 0,
                    "extra_tag": "非赠品",
                    "display_url": "",
                    "notify_url": "",
                    "jump_url": "",
                    "third_md5_key": "",
                    "free_postage": false,
                    "sale_time": null,
                    "auto_refund_deadline": null,
                    "extra_info": "{}",
                    "status": 1,
                    "created_at": "2019-10-12T11:24:19.000+08:00",
                    "updated_at": "2019-10-12T11:24:19.000+08:00",
                    "mall_online_sub_items": [
                        {
                            "id": 1,
                            "mall_online_item_id": 1,
                            "item_id": 0,
                            "sub_item_id": 0,
                            "title": "12341s24",
                            "price": "105.0",
                            "inner_name": "ZB00102V1-TXFF",
                            "remain": 0,
                            "url_image": "/image/items/m/uploads/1489136683902.jpg",
                            "extra_info": "{}",
                            "status": 1,
                            "created_at": "2019-10-12 11:24:19 +0800",
                            "updated_at": "2019-10-12 11:24:19 +0800"
                        },
                        {
                            "id": 2,
                            "mall_online_item_id": 1,
                            "item_id": 0,
                            "sub_item_id": 0,
                            "title": "vsdfga",
                            "price": "79.9",
                            "inner_name": "ZB00102-TXSB",
                            "remain": 0,
                            "url_image": "/image/items/m/uploads/1489136683903.jpg",
                            "extra_info": "{}",
                            "status": 1,
                            "created_at": "2019-10-12 11:24:19 +0800",
                            "updated_at": "2019-10-12 11:24:19 +0800"
                        },
                        {
                            "id": 3,
                            "mall_online_item_id": 1,
                            "item_id": 0,
                            "sub_item_id": 0,
                            "title": "fasdjh",
                            "price": "88.0",
                            "inner_name": "ZB00103V1-TXFF",
                            "remain": 0,
                            "url_image": "/image/items/m/uploads/23152435637.jpg",
                            "extra_info": "{}",
                            "status": 1,
                            "created_at": "2019-10-12 11:24:19 +0800",
                            "updated_at": "2019-10-12 11:24:19 +0800"
                        },
                    ]
                },
                delta: {},
                delta_html: ''
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            this.init();
        },
        watch: {
            item_id() {
                this.init();
            }
        },
        methods: {
            show(item_id) {
                this.loading = true;
                OnlineUtil.getMallItemDiffInfo(item_id).then((data) => {
                    this.old_item = data.old_item;
                    this.new_item = data.new_item;
                    this.genDiffHtml();
                }).catch((e) => {
                    this.$Modal.error({title: '错误', content: e.message});
                }).finally(() => {
                    this.loading = false;
                });
                this.modal = true;
            },
            init() {
                if (this.type === 'text' && this.item_id > 0) {
                    this.show(this.item_id);
                }
            },
            genDiffHtml() {
                this.delta = DiffPatcher.diff(this.old_item, this.new_item);
                console.log(this.delta);
                // this.delta_html = Diff.formatters.html.format(this.delta, this.old);
                this.delta_html = Diff.formatters.html.format(this.delta);
                this.delta_html = this.delta_html.replace(/jsondiffpatch-property-name">(\d+)<\/div>/g, (match, d, index) => {
                    return match.replace(/\d+/, `子项${parseInt(d) + 1}`);
                });
                // 把子项列表的位置换到最后
                // this.$nextTick(() => {
                //     const ul = this.$refs.delta.querySelector('ul.jsondiffpatch-node');
                //     const arr = ul.querySelector('li.jsondiffpatch-child-node-type-array');
                //     if (ul && arr) {
                //         ul.append(arr);
                //     }
                // });
            }
        }
    }
</script>
